import { Modal } from "react-bootstrap";
import { Button } from "../../../components";
import { useEffect, useState } from "react";
import { useAssetsManagement } from "../hooks/AssetsManagementContext";
import _ from "lodash";
import { FormInput } from "../../../components/forms";
import ProviderPagedSelect from "../../../components/forms/selects/ProviderPagedSelect";
import { useFilterContext } from "../../../hooks/FilterContext";
import ThemedModal from "../../../components/utilities/ThemedModal";

const AssetTableFilterModal = ({ show, onHide }) => {

    const { defaultFilters, filter, setFilter } = useFilterContext();
    const [tempFilters, setTempFilters] = useState(filter);

    const {
        assetName,
        sedol,
        provider,
        citicode
    } = tempFilters;

    const onApplyFilters = () => {
        setFilter((original) => {
            return {
                ...original,
                ...tempFilters,
            };
        });
        onClose();
    };
    
    const onFilterValueChanged = (property, value) => {
        setTempFilters((original) => {
            return {
                ...original,
                [property]: value,
            };
        });
    };

    const onClearFilters = () => {
        setTempFilters((_) => defaultFilters);
    };  

    const onClose = () => {
        onHide();
    };

    useEffect(() => {
            if (!_.isEqual(filter, tempFilters)) {
                setTempFilters((_) => filter);
            }
        }, [filter]);

    return (
        <Modal backdrop="static" centered size="lg" show={show} onHide={onHide}>
            <ThemedModal.Header closeButton>
                <Modal.Title>Filter Assets</Modal.Title>
            </ThemedModal.Header>
            <Modal.Body>
                <div className="row mb-3">
                    <div className="col">
                        <FormInput
                            label="Asset Name"
                            value={assetName ?? ""}
                            onChange={(e) => onFilterValueChanged("assetName", e.target.value)}
                        />
                    </div>
                    <div className="col">
                        <FormInput
                            label="Sedol"
                            value={sedol ?? ""}
                            onBlur={(value) => {
                                if(value !== ""){
                                    onFilterValueChanged("sedol", value)
                                }
                                else{
                                    onFilterValueChanged("sedol", null)
                                }

                            }}
                            disableAnimations
                        />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <FormInput
                            label="Citicode"
                            value={citicode ?? ""}
                            onBlur={(value) => {
                                if(value !== ""){
                                    onFilterValueChanged("citicode", value)
                                }
                                else{
                                    onFilterValueChanged("citicode", null)
                                }

                            }}
                            disableAnimations
                        />
                    </div>
                    <div className="col">
                        <ProviderPagedSelect
                            label="Provider"
                            value={provider}
                            setValue={value => onFilterValueChanged("provider", value)}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="warning" onClick={onClearFilters}>Clear Filters</Button>
                <Button variant="success" onClick={onApplyFilters}>Apply Filters</Button>
                <Button variant="light" onClick={onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AssetTableFilterModal;